var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { attrs: { justify: "center" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "630", "overlay-color": "grey-500" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "text-center" },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "px-4",
                  attrs: { color: "transparent", flat: "", height: "48" },
                },
                [
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "pt-7 mr-4",
                          attrs: { align: "center", justify: "center" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "", small: "" },
                              on: {
                                click: function ($event) {
                                  _vm.dialog = false
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { size: "20", color: "grey-500" } },
                                [_vm._v("mdi-close")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pb-7" },
                [
                  _c("v-img", {
                    attrs: {
                      contain: "",
                      height: 100,
                      src: require(`@/assets/alert-dialog/ax.svg`),
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticClass:
                        "d-block title mt-4 font-weight-bold green-500--text",
                    },
                    [
                      _vm._v(
                        "SII informa - Suspensión Temporal de Boleta Electrónica"
                      ),
                    ]
                  ),
                  _c("v-col", { staticClass: "text-left subtitle-2 pb-0" }, [
                    _vm._v(
                      " Le informamos que el Servicio de Impuestos Internos (SII) realizará una suspensión total del sistema de "
                    ),
                    _c("strong", [_vm._v("Boleta Electrónica")]),
                    _vm._v(" hoy "),
                    _c("strong", [_vm._v("miércoles 22 de octubre de 2025")]),
                    _vm._v(", desde las "),
                    _c("strong", [_vm._v("20:00 horas")]),
                    _vm._v(", con una duración máxima de "),
                    _c("strong", [_vm._v("4 horas")]),
                    _vm._v(
                      ". Durante este período no estarán disponibles los siguientes servicios: "
                    ),
                    _c("ul", { staticClass: "pl-6 mt-3" }, [
                      _c("li", [_vm._v("Recepción y validación de boletas.")]),
                      _c("li", [_vm._v("Consulta de validez de boletas.")]),
                      _c("li", [_vm._v("API de consulta y envío de boletas.")]),
                    ]),
                    _c("span", { staticClass: "d-block mt-3" }, [
                      _vm._v(
                        "Esto no impactará su operación, podrá seguir generando ventas."
                      ),
                    ]),
                    _c("span", { staticClass: "d-block mt-3" }, [
                      _vm._v(
                        "Nuestros sistemas están preparados para realizar la contención necesaria y enviar al SII todos los documentos al momento de ser activados sus servicios."
                      ),
                    ]),
                    _c("span", { staticClass: "mt-3 d-block" }, [
                      _vm._v("Atentamente Equipo Soporte"),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }